var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginXsightLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z",
    fill: "#000408"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6753 25.1578C20.7001 26.5691 22.3386 27.4042 24.0827 27.4042H27.1965L18.8955 15.9729L25.2175 7.31911H22.0815C20.343 7.31911 18.7089 8.14903 17.6833 9.55287L15.9533 11.9211L12.2651 6.84207C11.2404 5.43086 9.60181 4.5957 7.85777 4.5957H4.74396L19.6753 25.1578Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4482 19.864C14.222 20.9297 14.22 22.373 13.443 23.4365C12.8718 24.2185 11.9615 24.6808 10.9931 24.6808H6.63178L11.8044 17.6003L13.4482 19.864Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginXsightLogo);
export default __webpack_public_path__ + "static/media/login-xsight-logo.d3f8de30b060f832c27baafcfa8d752b.svg";
export { ForwardRef as ReactComponent };